import { api, type Config } from './api';

export async function get<T>(url: string, config?: Config): Promise<T> {
  const { params, ...rest } = config || {};
  return api<T>(`${url}${params ? `?${new URLSearchParams(params).toString()}` : ''}`, { ...rest });
}
